module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel04_770_280_ja-b71e10587e3ffeae8e6c9ef569c8aa5b.jpg";